module.exports = "/365FarmNet/dist/seedPopup.b7427422680058aee832c734704022c8.html";